import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	StarterDashboardV2CreateEndorsementMutation,
	StarterDashboardV2CreateEndorsementMutationVariables,
} from './createEndorsement.graphql';
import { StarterDashboardV2CreateEndorsement } from './createEndorsement.graphql';

export type CreateEndorsementInput = {
	petitionId: string;
	name: string;
	title?: string;
	url?: string;
	content?: string;
	photo?: {
		url: string;
		photoCrop?: {
			height: number;
			width: number;
			xOffset: number;
			yOffset: number;
		};
	};
};

export type CreateEndorsementResponse = NonNullable<StarterDashboardV2CreateEndorsementMutation['createEndorsement']>;

export async function createEndorsement(
	input: CreateEndorsementInput,
	{ gql: { fetch } }: UtilityContext,
): Promise<CreateEndorsementResponse> {
	const { data, errors } = await fetch<
		StarterDashboardV2CreateEndorsementMutation,
		StarterDashboardV2CreateEndorsementMutationVariables
	>({
		query: StarterDashboardV2CreateEndorsement,
		variables: { input },
		rejectOnError: false,
	});

	if (errors) throw new Error(JSON.stringify(errors));
	if (!data) throw new Error('Empty data in createEndorsement graphQL response');

	return data.createEndorsement;
}
